import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import OrganizationGroup from '@/repositories/data/OrganizationGroup';

export default class OrganizationInviteRepository extends BaseCrudRepository<
    OrganizationGroup,
    OrganizationGroup,
    string
> {
    constructor(client: HttpClient) {
        super(client, 'api/organization-groups/', 'CUSTOMERS');
    }

    protected formatIntrospectUrl(create: boolean, id: string, parentId?: any): string {
        if (parentId === undefined) {
            throw new Error('Parent ID required for introspection');
        }
        return parentId + '/introspect';
    }
}
